import type {JSX} from 'react';
import styles from './sp-footer.module.css';

export function SpFooter({...props}: JSX.IntrinsicElements['div']) {
  return (
    <div className={styles.footer} {...props}>
      <div className={styles.content}>
        <ul className={styles.linkList}>
          <li className={styles.linkItem}>
            <p>会社概要</p>
          </li>
          <li className={styles.linkItem}>
            <p>プライバシーポリシー</p>
          </li>
          <li className={styles.linkItem}>
            <p>利用規約</p>
          </li>
        </ul>
        <ul className={styles.contactList}>
          <li className={styles.contactItem}>
            <p>報道関係者からのお問い合わせ</p>
          </li>
          <li className={styles.contactItem}>
            <p>企業様からのお問い合わせ</p>
          </li>
          <li className={styles.contactItem}>
            <p>一般の皆様からのお問い合わせ</p>
          </li>
        </ul>
        <small className={styles.copyright}>
          Copyright &copy; PR TIMES Corporation All Rights Reserved.
        </small>
      </div>
    </div>
  );
}
